import React from 'react';
import Page from '../components/Page';

class HomePage extends React.Component {
  render() {
    return (
      <Page
        className="Homepage"
        title="Dashboard"
        breadcrumbs={[{ name: 'Dashboard', active: true }]}
      ></Page>
    );
  }
}
export default HomePage;
